import type { SemanticPaletteColors } from '../types';

export const defaultLightSemanticPalette: SemanticPaletteColors = {
  primary: {
    darker: '#002962',
    dark: '#003A8C',
    main: '#096DD9',
    light: '#48ACFF',
    lighter: '#91D5FF',
    muted: '#E6F7FF',
    contrastText: '#FFFFFF',
  },
  error: {
    darker: '#950303',
    dark: '#BA0404',
    main: '#CC2424',
    light: '#F06562',
    lighter: '#F8B2B1',
    muted: '#FDECEB',
    contrastText: '#FFFFFF',
  },
  warning: {
    darker: '#B64000',
    dark: '#E35000',
    main: '#F26F03',
    light: '#FBA134',
    lighter: '#FDD099',
    muted: '#FEF3E6',
    contrastText: '#FFFFFF',
  },
  info: {
    darker: '#374B5D',
    dark: '#466077',
    main: '#557591',
    light: '#829DB5',
    lighter: '#B5C5D4',
    muted: '#E9EDF2',
    contrastText: '#FFFFFF',
  },
  success: {
    darker: '#134216',
    dark: '#1B5E20',
    main: '#2E7D32',
    light: '#70BF73',
    lighter: '#B7DFB9',
    muted: '#EDF7ED',
    contrastText: '#FFFFFF',
  },
};
